import { Box } from "@mui/material";
import type { SxProps } from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import type { ReactNode } from "react";

interface SortIconsUpProps {
  up: boolean;
  down?: never;
}
interface SortIconsDownProps {
  up?: never;
  down: boolean;
}

type SortIconsProps = SortIconsUpProps | SortIconsDownProps;

const arrowCommonSx: SxProps = {
  position: "absolute",
  margin: 0,
  left: "-6px",
};

export function SortIcons({ up = false, down = false }: Readonly<SortIconsProps>): ReactNode {
  return (
    <Box sx={{ height: "16px", width: "12px", position: "relative" }}>
      <ArrowDropUpIcon color={up ? "info" : "disabled"} sx={{ ...arrowCommonSx, top: "-10px" }} />
      <ArrowDropDownIcon
        color={down ? "info" : "disabled"}
        sx={{ ...arrowCommonSx, bottom: "-10px" }}
      />
    </Box>
  );
}

export function UnsortedIcon(): ReactNode {
  return <SortIcons up={false} />;
}

export function SortIconUp(): ReactNode {
  return <SortIcons up />;
}

export function SortIconDown(): ReactNode {
  return <SortIcons down />;
}
